import { render } from "./AdminIndex.vue?vue&type=template&id=64e37ac9"
import script from "./AdminIndex.vue?vue&type=script&lang=js"
export * from "./AdminIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__